module.exports = __webpack_public_path__ + "load.65e20c6a.png";